import React from 'react';
import { message } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import Detail from './components/Payment/Detail';
import TurnAway from './components/Payment/TurnAway';
import Refund from './components/Payment/Refund';
import { checkOutState, backMoneyType } from '../../axios/dictionaries';
import { postFrom, config, transterQuery } from '../../axios';
import { moneyAddComma } from '../../utils/index'
import axios from 'axios'
import moment from 'moment'
import { handleExportParams } from '../../utils';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                billBeginDate: "",
                billEndDate: "",
                billId: "",
                buildingName: "",
                contractId: "",
                customerId: "",
                customerName: "",
                houseId: "",
                keyword: "",
                merchantName: "",
                mustPayDateEnd: "",
                mustPayDateStart: "",
                pageSize: 10,
                phone: "",
                projectName: "",
                receiveStatus: "",
                roomNo: "",
                shortName: "",
                receiveOrPay: 2
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showDetailModal: false, //显示详情
            showTurnAwayModal: false, //显示转入其它合同
            showRefundModal: false, //显示退款
            inputSearchTerm: "170px", //查询条件宽度
        }
    }

    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current, merchantId } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values, { merchantId });
        } else {
            data = Object.assign({}, params, values, { current, merchantId });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        axios.all([
            postFrom({ url: config.API_bill_findBillEndPageList, data }),
            // postFrom({url: config.API_bill_findBillCount, data}),
        ]).then(axios.spread((listRes) => {
            this.setState({ current: listRes.current, tableTotal: listRes.total, tableData: listRes.records, tableLoading: false });
        })).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }

    handleShowDetail = (id) => { //显示详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPackage(id);
    }

    handleTurnAway = (id) => { //转入其它合同
        this.setState({ showTurnAwayModal: true });
        this.turnAwayRef.loadPackage(id);
    }

    handleShowRefund = (id) => { //退款
        this.setState({ showRefundModal: true });
        this.refundRef.loadPackage({ id });
    }

    componentDidMount() {
        this.handleSearch()
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showDetailModal,
            showTurnAwayModal,
            showRefundModal,
            inputSearchTerm,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column' }}>
                    <SuperForm
                        data={searchData({ inputSearchTerm })}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                    <div className="search-btn-list">
                        <AuthButton authkey="e-2-3" type="primary" icon="export" href={`${config.API_bill_billEndExprotDate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出
                        </AuthButton>
                    </div>
                </div>
                <TableDOM
                    columns={columns({ handleTurnAway: this.handleTurnAway, handleShowRefund: this.handleShowRefund, handleShowDetail: this.handleShowDetail })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={() => { this.setState({ showDetailModal: false }) }}
                />
                <TurnAway
                    onRef={ref => this.turnAwayRef = ref}
                    visible={showTurnAwayModal}
                    handleCancel={() => { this.setState({ showTurnAwayModal: false }) }}
                    handleGetList={this.handleSearch}
                />
                <Refund
                    onRef={ref => this.refundRef = ref}
                    visible={showRefundModal}
                    handleCancel={() => { this.setState({ showRefundModal: false }) }}
                    handleGetList={this.handleSearch}
                />
            </PageWrap>
        )
    }


}

const searchData = ({ inputSearchTerm }) => {
    let data = [
        {
            tagName: 'Input',
            formConfig: { name: 'shortName' },
            attribute: { placeholder: '输入商户简称', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectName' },
            attribute: { placeholder: '输入项目名称', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'buildingName' },
            attribute: { placeholder: '输入楼栋', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '输入房号', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'mustPayDateStart' },
            attribute: { placeholder: '请选择应退开始日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'mustPayDateEnd' },
            attribute: { placeholder: '请选择应退结束日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'customerName' },
            attribute: { placeholder: '输入租客', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'phone' },
            attribute: { placeholder: '输入手机号码', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'billBeginDate' },
            attribute: { placeholder: '请选择完成开始日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: 'billEndDate' },
            attribute: { placeholder: '请选择完成结束日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'Select',
            formConfig: { name: 'payStatus' },
            attribute: { placeholder: '请选择退款状态', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(checkOutState), //.concat(dicHouseStatus)
            notResult: '',
        },
    ]
    handleExportParams().merchantId ? data.splice(0, 1) : '';
    return data;
};

const columns = ({ handleTurnAway, handleShowRefund, handleShowDetail }) => [
    {
        title: '应退日期',
        dataIndex: 'mustPayDate',

        render(text, record, index) {
            return <span>
                <div>{record.mustPayDate ? moment(record.mustPayDate).format('YYYY-MM-DD') : ""}</div>
            </span>
        }
    },
    {
        title: '房源',
        dataIndex: 'houseId',

        render(text, record, index) {
            return <span>
                <div>{record.roomNo ? record.roomNo : null}</div>
                <div>{record.buildingName ? record.buildingName : null}</div>
            </span>
        }
    },
    {
        title: '租客',
        dataIndex: 'customerName',

        render(text, record, index) {
            return <span>
                <div>{record.customerName ? record.customerName : null}</div>
                <div>{record.phone ? record.phone : null}</div>
            </span>
        }
    },
    {
        title: '退款原因',
        dataIndex: 'feeRemark',
    },
    {
        title: '应退 | 可退（元）',
        dataIndex: 'receivedMoney',
        align: 'right',
        render(text, record, index) {
            return <span>
                <div>{record.billMoney ? moneyAddComma(record.billMoney) : null}</div>
                {
                    record.paidMoney
                        ? <React.Fragment>
                            <div style={{ color: "red" }}>{record.paidMoney ? moneyAddComma(record.billMoney-record.paidMoney) : null}</div>
                        </React.Fragment>
                        : null
                }
            </span>
        }
    },
    {
        title: '实际退款方式',
        dataIndex: 'offlinePayType',
        render(text, record, index) {
            let now = backMoneyType.find(item => item.value === text);
            if (now)
                return <span>
                    <div>{now.title}</div>
                </span>
            return null
        }
    },
    {
        title: '退款状态 | 完成日期',
        dataIndex: 'payStatus',
        render(text, record, index) {
            let now = checkOutState.find(item => item.value === text);
            if (now)
                return <span>
                    <div>{now.title}</div>
                    <div >{record.finishDate ? moment(record.finishDate).format('YYYY-MM-DD') : null}</div>
                </span>
            return null
        }
    },
    {
        title: '商户 | 项目',
        dataIndex: 'mustPhayDdate1',

        render(text, record, index) {
            return <span>
                <div>{record.shortName ? record.shortName : null}</div>
                <div>{record.projectName ? record.projectName : null}</div>
            </span>
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 170,
        render(text, record, index) {
            return <div className="table-action">
                {
                    record.payStatus === 1
                        ? <React.Fragment>
                            <AuthButton authkey="e-2-5"><span className="showClickDetail" onClick={() => { handleTurnAway(record.id) }}>转入收款账单</span></AuthButton>
                            <AuthButton authkey="e-2-4"><span className="showClickDetail" onClick={() => { handleShowRefund(record.id) }}>退款</span></AuthButton>
                        </React.Fragment>
                        : null
                }
                <AuthButton authkey="e-2-2"><span className="showClickDetail" onClick={() => { handleShowDetail(record.id) }}>详情</span></AuthButton>
            </div>
        }
    },
];


// WEBPACK FOOTER //
// ./src/page/Bill/Payment.js